
import { useSidebarState } from "@/hooks/useSidebarState";
import { usePermissions } from "@/hooks/usePermissions";
import { AppSidebarMenu } from "./SidebarMenu";

export function FilteredSidebarMenu() {
  const {
    expandedItems,
    showIcons,
    isCollapsed,
    toggleExpanded,
    isActive,
    isParentActive
  } = useSidebarState();

  const { getFilteredMenuItems, hasPermission } = usePermissions();
  const filteredMenuItems = getFilteredMenuItems();

  // فلترة العناصر بناءً على الصلاحيات - إظهار المسموح به فقط
  const getPermissionFilteredItems = (items: any[]): any[] => {
    if (!Array.isArray(items)) {
      console.warn('getPermissionFilteredItems: items is not an array', items);
      return [];
    }

    return items.map(item => {
      if (!item) return null;

      // إنشاء نسخة من العنصر لتجنب تعديل الأصل
      const filteredItem = { ...item };
      
      // إذا كان العنصر له صلاحية محددة، التحقق من وجودها
      if (item.permission && !hasPermission(item.permission)) {
        return null;
      }
      
      // فلترة العناصر الفرعية
      if (item.subItems && Array.isArray(item.subItems)) {
        const filteredSubItems = getPermissionFilteredItems(item.subItems).filter(Boolean);
        
        // إذا كان العنصر الأساسي يحتوي على عناصر فرعية فقط ولا يوجد له مسار مباشر
        if (item.href === '#' && filteredSubItems.length === 0) {
          return null;
        }
        
        filteredItem.subItems = filteredSubItems;
      }
      
      return filteredItem;
    }).filter(Boolean);
  };

  const finalFilteredItems = getPermissionFilteredItems(filteredMenuItems);

  // تمرير البيانات للمكون الرئيسي
  return (
    <AppSidebarMenu 
      orderedMenuItems={finalFilteredItems}
      expandedItems={expandedItems}
      showIcons={showIcons}
      isCollapsed={isCollapsed}
      toggleExpanded={toggleExpanded}
      isActive={isActive}
      isParentActive={isParentActive}
    />
  );
}
